import { HeartIcon, PlusIcon } from 'lucide-react';
import { Button } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
import { FormSectionV2, PersonaRepeaterRows } from '../../PersonaFormSectionsV2';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

/* eslint-disable i18next/no-literal-string -- react-hook-form field paths, not copy */
const FIELD_ARRAY_NAME = 'caresAbout';
const ITEM_FIELD = 'item';
const DESCRIPTION_FIELD = 'description';
/* eslint-enable i18next/no-literal-string */

export function CaresAboutSectionV2() {
  const { t } = useTranslation('audiences');
  const { control, caresAboutArray } = useEditPersonaFormContext();

  return (
    <FormSectionV2
      icon={<HeartIcon className="size-5" />}
      title={t('audiences.caresAboutSection.caresAbout')}
      headerAction={
        <Button
          variant="outline"
          size="sm"
          onClick={() => caresAboutArray.append({ item: '', description: '' })}
        >
          <PlusIcon className="size-4" />
          {t('audiences.caresAboutSection.addItem')}
        </Button>
      }
    >
      <PersonaRepeaterRows
        control={control}
        name={FIELD_ARRAY_NAME}
        fields={caresAboutArray.fields}
        onRemove={caresAboutArray.remove}
        columns={[
          {
            name: ITEM_FIELD,
            label: t('audiences.caresAboutSection.item'),
            required: isNestedFieldRequired('caresAbout', 'item'),
            className: 'w-1/3',
          },
          {
            name: DESCRIPTION_FIELD,
            label: t('audiences.caresAboutSection.description'),
            required: isNestedFieldRequired('caresAbout', 'description'),
          },
        ]}
      />
    </FormSectionV2>
  );
}

CaresAboutSectionV2.displayName = 'CaresAboutSectionV2';
